var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.8,300.2l-38.5-95.3c-10-24.7-33.7-40.7-60.4-40.7h-22.8c16.7-17.4,27-41.1,27-67.1 C353.1,43.6,309.5,0,256,0s-97.1,43.6-97.1,97.1c0,26,10.3,49.6,27,67.1h-22.8c-26.7,0-50.4,16-60.4,40.7l-38.5,95.3 c-9.6,23.9-2.9,51,16.8,67.6l52.9,44.6c11.7,56.8,62,99.6,122.2,99.6c60.2,0,110.5-42.8,122.2-99.6l52.9-44.6 C450.7,351.2,457.5,324,447.8,300.2z M188.9,97.1c0-37,30.1-67.1,67.1-67.1s67.1,30.1,67.1,67.1c0,37-30.1,67.1-67.1,67.1 S188.9,134.1,188.9,97.1z M167.9,422l13.7,2.3l7.2-22h23c4.7,13.7,15.5,24.6,29.2,29.2v49.3C207.6,475.5,180,452.6,167.9,422z  M192.1,317.4c16.9-15.4,39.3-24.8,63.9-24.8c24.6,0,47,9.4,63.9,24.8l-22.3,6.4l15.8,48.5h-13.2c-6.3-18.4-23.7-31.7-44.2-31.7 s-38,13.3-44.2,31.7h-13.2l15.8-48.5L192.1,317.4z M256,404c-9.2,0-16.7-7.5-16.7-16.7s7.5-16.7,16.7-16.7s16.7,7.5,16.7,16.7 S265.2,404,256,404z M271,480.8v-49.3c13.7-4.7,24.6-15.5,29.2-29.2h23l7.2,22l13.7-2.3C332,452.6,304.4,475.5,271,480.8z  M411.7,344.9l-52.5,44.3l-8.3,1.4l-15.1-46.5l12.7-3.6l16.8,0.5l0.8-30l-11.9-0.3c-22.8-29.2-58.4-48-98.3-48 c-39.9,0-75.4,18.8-98.2,48l-11.9,0.3l0.8,30l16.8-0.5l12.7,3.6l-15.1,46.5l-8.3-1.4l-52.5-44.3c-9.7-8.2-13.1-21.7-8.3-33.5 l38.5-95.3c5.4-13.3,18.2-22,32.6-22h185.9c14.4,0,27.2,8.6,32.6,22l38.5,95.3C424.8,323.2,421.5,336.7,411.7,344.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.9b14b31d3c6669e445ceb4b9ae00d3dc.svg";
export { ForwardRef as ReactComponent };